import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Error500Icon } from '../../../../assets/icons/error-pages/error500.svg';
import CommonErrorPage from '../CommonErrorPage/CommonErrorPage';

const ServerErrorPage = () => {
  const { t } = useTranslation();

  return (
    <CommonErrorPage
      errorTone="server"
      errorIcon={Error500Icon}
      statusCode="500"
      title={t('errorPages.server.title')}
      description={t('errorPages.server.description')}
      buttonText={t('errorPages.server.goHome')}
    />
  );
};

export default ServerErrorPage;
